import React, { useState, useEffect, } from 'react';
import { Tabs, Tab, Form, Button, FloatingLabel } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { sendRequest } from '../../apis/APIs';
import { handleApiResponse } from '../../apis/apiUtils';
import { callCommonAction } from '../../redux/Common/CommonReducer';
import { useNavigate } from 'react-router-dom';
import appRoutes from '../../configs/AppRoutes';
import { validateUserFormData } from './Validation';
import { validateUserPasswordFormData } from './UpdatePasswordValidation';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css'; // or another theme like 'style.css'

import { toast } from 'react-toastify';
import Header from '../Header/AppHeader';



const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, loading1 } = useSelector((state) => state.common);

  const [showSecond, setShowSecond] = useState(false);

  const handleClick = () => {
    setShowSecond(true);
  };
  const handleBack = () => {
    setShowSecond(false);
  };

  const [userDetail, setUserDetail] = useState({
    name: '',
    email: '',
    phone_no: '',
    file: '',
    current_password: '',
    password: '',
    password_confirmation: ''
  });
  const [errorsInfo, setErrorsInfo] = useState({});
  const [fileName, setFileName] = useState('');
  const [filePreview, setFilePreview] = useState(null);

  useEffect(() => {
    getUserData();
  }, []);

const getUserData = async () => {
  try {
    const res = await sendRequest('/user/data', 'GET');
    if (res.data.type === 'success') {
      setUserDetail((prev) => ({
        ...prev,
        name: res.data.data.name,
        email: res.data.data.email,
        phone_no: res.data.data.phone_no,
      }));
      if (res.data.data.full_file_path) {
        setFilePreview(res.data.data.full_file_path);
      }
    } else {
      // Optional: Handle the case where response is not 'success'
      console.error("Failed to fetch user data", res.data.message);
    }
  } catch (error) {
    // Log the actual error
    console.error("Error fetching user data:", error);
  }
};


  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
      setFilePreview(URL.createObjectURL(file));
      setUserDetail((prev) => ({
        ...prev,
        file: file
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetail((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const checkFormIsValid = async (isPasswordTab = false) => {
    const res = validateUserFormData(userDetail, isPasswordTab);
    setErrorsInfo(res.errors);
    return res.formVaildCheck;
  };

  const saveUserDetail = async (e) => {
    e.preventDefault();
    const formValid = await checkFormIsValid(false);
    if (!formValid) return;

    try {
      dispatch(callCommonAction({ loading: true }));
      const formData = new FormData();
      formData.append('name', userDetail.name);
      formData.append('email', userDetail.email);
      formData.append('phone_no', userDetail.phone_no);

      if (userDetail.file) {
        formData.append('file', userDetail.file);
      }

      const detailRes = await sendRequest('/user/data-update', 'POST', formData);
      dispatch(callCommonAction({ loading: false }));

      handleApiResponse(detailRes);

      if (detailRes.data.type === 'success') {
        localStorage.setItem('user', JSON.stringify(detailRes.data.user));
        dispatch(callCommonAction({ user: detailRes.data.user }));
      
      }
    } catch (error) {
      dispatch(callCommonAction({ loading: false }));
      toast.error('Something went wrong');
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (await checkFormIsValidPassword("")) {
      try {
        dispatch(callCommonAction({ loading1: true }));
        const passwordPayload = {
          current_password: userDetail.current_password,
          password: userDetail.password,
          password_confirmation: userDetail.password_confirmation
        };

        const passwordRes = await sendRequest('/user/password', 'POST', passwordPayload);
        dispatch(callCommonAction({ loading1: false }));

        handleApiResponse(passwordRes);

        if (passwordRes.data.type === 'success') {
          setUserDetail((prev) => ({
            ...prev,
            current_password: '',
            password: '',
            password_confirmation: ''
          }));
        }
      } catch (error) {
        dispatch(callCommonAction({ loading1: false }));

        toast.error(error?.response?.data?.message);
      }
    }
  };

  /** Validation implemented here */
  const checkFormIsValidPassword = async (fieldName) => {
    const passwordPayload = {
      current_password: userDetail.current_password,
      password: userDetail.password,
      password_confirmation: userDetail.password_confirmation
    };
    const res = validateUserPasswordFormData(passwordPayload, fieldName);
    setErrorsInfo(res.errors);
    return res.formVaildCheck;
  };

  return (
    <>
      <div class="pt-3 pb-5">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-7 mx-auto">
              <div class="card custom-card px-0 rounded-4">
                <div class="card-header d-flex justify-content-between align-items-center bg-white rounded-4 border-0 px-4 py-3">
                  <h5 class="mb-0">My Profile</h5>
                  {showSecond &&
                    <button onClick={handleBack} className=" px-3 btn btn-outline-custom btn-sm d-inline-flex  py-2 rounded-3">
                      <span className="d-inline-flex align-items-center">
                        <iconify-icon icon="icon-park-solid:left-c" class="fs-18 yellow me-1"></iconify-icon> Back</span>
                    </button>
                  }

                </div>
                <div className='card-body px-5 pt-5 border-top'>
                  {!showSecond &&
                    <form encType="multipart/form-data">
                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                          <label className='form-label fw-medium'>Avatar</label>
                        </div>
                        <div class="col-12 col-lg-9">
                          <div className="icon-picture mb-3 position-relative">
                            {filePreview && filePreview !== 'https://api.cad.kleeberg.com/storage/' && !filePreview.includes('null') ? (
                              <>
                                <img src={filePreview} alt={fileName || "Preview"} className="preview-img" />
                                <label className="edit-icon d-flex align-items-center justify-content-center position-absolute shadow" htmlFor="fileInput">
                                  <iconify-icon icon="mingcute:edit-line" class="fs-18 yellow"></iconify-icon>
                                </label>
                              </>
                            ) : (
                              <>
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/images/avatar_placeholder.png`}
                                  alt="Default Preview"
                                  className="preview-img"
                                />
                                <label className="edit-icon d-flex align-items-center justify-content-center position-absolute shadow" htmlFor="fileInput">
                                  <iconify-icon icon="mingcute:edit-line" class="fs-18 yellow"></iconify-icon>
                                </label>
                              </>
                            )}

                            <input
                              type="file"
                              id="fileInput"
                              name="file"
                              accept="image/*"
                              onChange={handleFileChange}
                              style={{ display: 'none' }}
                            />
                          </div>
                          <div className="error-message" style={{ color: 'red' }}>{errorsInfo.file}</div>



                          <p className='fs-12 m-0'>Allowed file types: png, jpg, jpeg.</p>
                        </div>

                      </div>
                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                          <label className='form-label fw-medium'>Full Name</label>
                        </div>
                        <div class="col-12 col-lg-9">
                          <Form.Group controlId="name" className="">
                            <Form.Control
                              className='bg-body-tertiary'
                              type="text"
                              name="name"
                              value={userDetail.name}
                              onChange={handleChange}
                            />
                            <div className="error-message" style={{ color: 'red' }}>{errorsInfo.name}</div>
                          </Form.Group>
                        </div>
                      </div>


                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                          <label className='form-label fw-medium'>Contact Phone</label>
                        </div>
                        <div class="col-12 col-lg-9">
                          <PhoneInput
                            country={'us'} // Default country (change as needed)
                            value={userDetail.phone_no}
                            onChange={(phone) =>
                              setUserDetail((prev) => ({
                                ...prev,
                                phone_no: phone
                              }))
                            }
                            inputProps={{
                              name: 'phone_no',
                              required: true,
                              className: 'form-control'
                            }}
                            inputStyle={{ width: '100%' }}
                          />
                          <div className="error-message" style={{ color: 'red' }}>{errorsInfo.phone_no}</div>
                        </div>
                      </div>
                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                          <label className='form-label fw-medium'>Email Address</label>
                        </div>
                        <div class="col-12 col-lg-9">
                          <Form.Group controlId="Email" className="">
                            <Form.Control
                              className='bg-body-tertiary'
                              type="email"
                              name="email"
                              disabled
                              value={userDetail.email}
                              onChange={handleChange}
                            />
                            <div className="error-message" style={{ color: 'red' }}>{errorsInfo.email}</div>
                          </Form.Group>
                        </div>
                      </div>
                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                        </div>
                        <div class="col-12 col-lg-9">
                          <button type="submit" onClick={saveUserDetail} disabled={loading} className="align-items-center me-3 btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3 mb-3">
                            {
                              loading
                                ? <span className="indicator-progress" style={{ display: 'block' }}>
                                  Please wait...
                                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                : <span className="text-uppercase">Update Profile</span>
                            }
                          </button>
                          <button onClick={handleClick} className="align-items-center me-3 btn btn-outline-custom btn-sm d-inline-flex px-3 py-2 rounded-3 text-uppercase mb-3">
                            Change Password
                          </button>
                        </div>
                      </div>
                    </form>
                  }


                  {showSecond &&
                    <form>

                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                          <label className='form-label fw-medium'>Current Password</label>
                        </div>
                        <div class="col-12 col-lg-9">
                          <Form.Group controlId="Current">
                            <Form.Control
                              className='bg-body-tertiary'
                              type="password"
                              name="current_password"
                              value={userDetail.current_password}
                              onChange={handleChange}
                              onBlur={() => checkFormIsValidPassword("current_password")}
                            />
                            {errorsInfo.current_password && (<p className="text-danger small m-0">{errorsInfo.current_password}</p>)}

                          </Form.Group>
                        </div>
                      </div>

                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                          <label className='form-label fw-medium'>New Password</label>
                        </div>
                        <div class="col-12 col-lg-9">
                          <Form.Group controlId="New">
                            <Form.Control
                              className='bg-body-tertiary'
                              type="password"
                              name="password"
                              value={userDetail.password}
                              onChange={handleChange}
                              onBlur={() => checkFormIsValidPassword("password")}

                            />
                            {errorsInfo.password && (<p className="text-danger small m-0">{errorsInfo.password}</p>)}

                          </Form.Group>
                        </div>
                      </div>

                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                          <label className='form-label fw-medium'>Confirm Password</label>
                        </div>
                        <div class="col-12 col-lg-9">
                          <Form.Group controlId="Confirm">
                            <Form.Control
                              className='bg-body-tertiary'
                              type="password"
                              name="password_confirmation"
                              value={userDetail.password_confirmation}
                              onChange={handleChange}
                              onBlur={() => checkFormIsValidPassword("password_confirmation")}

                            />
                            {errorsInfo.password_confirmation && (<p className="text-danger small m-0">{errorsInfo.password_confirmation}</p>)}

                          </Form.Group>
                        </div>
                      </div>
                      <div class="row mb-4">
                        <div class="col-12 col-lg-3">
                        </div>
                        <div class="col-12 col-lg-9">
                          <button type="submit" onClick={changePassword} disabled={loading1} className="align-items-center  btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3">
                            {
                              loading1
                                ? <span className="indicator-progress" style={{ display: 'block' }}>
                                  Please wait...
                                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                : <span className="text-uppercase">Update Password</span>
                            }
                          </button>
                        </div>
                      </div>



                    </form>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default Profile;
